module.exports = __webpack_public_path__ + "img/logo.3be30c5.svg";